import React from 'react'

import Container from '../Container'

const Users = ({ children }) => (
  <>
    <Container as="main">
      {children}
    </Container>
  </>
)

export default Users
